import { createRouter, createWebHistory } from 'vue-router'
import WelcomeView from '@/views/WelcomeView.vue'
import SelfieView from '@/views/SelfieView.vue'
import QuizView from '@/views/QuizView.vue'
import ProcessingView from '@/views/ProcessingView.vue'
import PersonaRevealView from '@/views/PersonaRevealView.vue'
import GeneratingView from '@/views/GeneratingView.vue'
import ResultView from '@/views/ResultView.vue'
import TestGenerationView from '@/views/TestGenerationView.vue'

const routes = [
  { path: '/', component: WelcomeView },
  { path: '/selfie', component: SelfieView },
  { path: '/quiz', component: QuizView },
  { path: '/processing', component: ProcessingView },
  { path: '/persona', component: PersonaRevealView },
  { path: '/generating', component: GeneratingView },
  { path: '/result', component: ResultView },
  { path: '/test', component: TestGenerationView },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
